"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentArgs = exports.availableWeights = exports.availableOrientations = exports.weights = exports.orientations = void 0;
var orientations = Object.freeze({
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
});
exports.orientations = orientations;
var weights = Object.freeze({
  DEFAULT: "default",
  STRONG: "strong"
});
exports.weights = weights;
var availableOrientations = Object.freeze(Object.values(orientations));
exports.availableOrientations = availableOrientations;
var availableWeights = Object.freeze(Object.values(weights));
exports.availableWeights = availableWeights;
var componentArgs = {
  orientation: {
    options: availableOrientations,
    control: {
      type: "radio"
    }
  },
  weight: {
    options: availableWeights,
    control: {
      type: "radio"
    }
  }
};
exports.componentArgs = componentArgs;